<div class="wrap" fxLayout="row" fxLayoutAlign="center center">
  <div class="app-error" fxLayout="column" fxLayoutGap="16px">
    <div class="fix" fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="16px">
      <mat-icon class="error-icon" color="warn">error</mat-icon>
      <div class="error-text">
        <h1 class="error-title">404</h1>
        <div class="error-subtitle">Página não encontrada</div>
      </div>
    </div>

    <div fxLayout="row" fxLayoutGap="16px">
      <button
        [routerLink]="['/']"
        class="mb-16 mr-8"
        color="primary"
        mat-flat-button>Voltar para o início
      </button>

      <button
        color="warn"
        mat-flat-button>Falar com nossos atentendes
      </button>
    </div>
  </div>
</div>
